// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"40ae888a","178":"1a175544","377":"9a7a060b","450":"750bf8ad","512":"4ad14786","895":"a209137b"}[chunkId] + ".chunk.css";
};